export default "__VITE_ASSET__rsGGuZQuVuOeO_Vs4vUrkA__"